import getEnv from './getEnv';

export const ENV = getEnv('ENV', 'development');
export const BACKEND = getEnv('BACKEND', 'http://localhost:5000');
export const HOST = getEnv('HOST', 'http://localhost:3000');
export const API_ONEID = getEnv('API_ONEID', 'https://testoneid.inet.co.th');
export const ONEID_CLIENT_ID = getEnv('ONEID_CLIENT_ID', '514');
export const ONEID_CODE = getEnv('ONEID_CODE', 'code');
export const REDIRECT_URI = getEnv('REDIRECT_URI', 'http://localhost:3000/onecallback');

export const BASEURL = getEnv('BASEURL', '');
export const URL = `${window.location.origin}${BASEURL === undefined ? '' : `/${BASEURL}`}`;

